const stores = [
    { name: "Rahim Store", value: 2 },
    { name: "Karim Store", value: 2 },
    { name: "Dhanmondi Branch", value: 3 },
];

export default stores;
